import gaEvents from '~js/ga-events'
import {
  POPUP
} from '~js/constants'

const state = {
  isPopupActive: false,
  popupUrl: '',
  popupMarker: {},
  popupSizeConfig: {
    type: POPUP.TYPE,
    fullHeight: POPUP.FULL_HEIGHT,
    widthPercent: POPUP.WIDTH_PERCENT,
    transparent: POPUP.TRANSPARENT
  },
  forceClientClosePopup: false
}

export const getters = {
  isPopupActive: state => state.isPopupActive,
  popupUrl: state => state.popupUrl,
  popupSizeConfig: state => state.popupSizeConfig,
  popupMarker: state => state.popupMarker,
  forceClientClosePopup: state => state.forceClientClosePopup

}

export const actions = {
  showPopup ({ commit, state, rootState }) {
    if (state.isPopupActive === false) {
      commit('SET_POPUP_ACTIVE', true)
      gaEvents.sendEvent('Building', 'ShowPopup', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    }
  },

  closePopup ({ dispatch, commit, state, rootState }) {
    if (state.isPopupActive === true) {
      commit('SET_POPUP_ACTIVE', false)
      gaEvents.sendEvent('Building', 'ClosePopup', rootState.route.params.buildingId || rootState.buildings.currentBuilding.objectId || '')
    } else {
      dispatch('forceCloseClientPopupWindow', true)
    }
  },

  setPopupUrl ({ commit }, url = '') {
    commit('SET_POPUP_URL', url)
  },

  setPopupMarker ({ commit }, marker = {}) {
    commit('SET_POPUP_MARKER', marker)
  },

  setPopupSizeConfig ({ commit }, {
    type = POPUP.TYPE,
    fullHeight = POPUP.FULL_HEIGHT,
    widthPercent = POPUP.WIDTH_PERCENT,
    transparent = POPUP.TRANSPARENT
  } = {}) {
    commit('SET_POPUP_SIZE_CONFIG', { type, fullHeight, widthPercent, transparent })
  },
  forceCloseClientPopupWindow ({ commit }, bool) {
    commit('FORCE_CLOSE_CLIENT_POPUP_WINDOW', bool)
  }
}

export const mutations = {
  SET_POPUP_ACTIVE (state, bool = false) {
    state.isPopupActive = bool
  },

  SET_POPUP_URL (state, url = '') {
    state.popupUrl = url
  },

  SET_POPUP_MARKER (state, marker = {}) {
    state.popupMarker = marker
  },

  SET_POPUP_SIZE_CONFIG (state, config) {
    state.popupSizeConfig = config
  },
  FORCE_CLOSE_CLIENT_POPUP_WINDOW (state, bool) {
    state.forceClientClosePopup = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
